import { useEffect, useState } from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SearchIcon from "@mui/icons-material/Search";
import { CSVLink } from "react-csv";

const IncomingData = [
  {
    td1: "INV-3066",
    td2: "Bedanta Baruah",
    td3: `Bedanta Baruah`,
    td4: "Paid",
    td5: "1799",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "UPI",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-7865",
    td2: "Mohit Gopal",
    td3: `Mohit Gopal`,
    td4: "Unpaid",
    td5: "7999",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "Net Banking",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-9874",
    td2: "Bedanta Baruah",
    td3: `Bedanta Baruah`,
    td4: "Overdue",
    td5: "1799",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "Debit Card",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-7531",
    td2: "Mohit Gopal",
    td3: `Mohit Gopal`,
    td4: "Unpaid",
    td5: "1799",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "Credit Card",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-8546",
    td2: "Bedanta Baruah",
    td3: `Bedanta Baruah`,
    td4: "Paid",
    td5: "1500",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "Net Banking",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-3579",
    td2: "Mohit Gopal",
    td3: `Mohit Gopal`,
    td4: "Unpaid",
    td5: "1499",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "Cash On Delivery",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-9516",
    td2: "Bedanta Baruah",
    td3: `Bedanta Baruah`,
    td4: "Overdue",
    td5: "1399",
    td6: "01.01.2022",
    td7: "10:20:55",
    td8: "Cash On Delivery",
    td9: "VIEW DETAILS",
  },
];

const DashBoardInvoiceTable = () => {
  const [count, setCount] = useState([]);
  const [type, setType] = useState(0);
  const [filtr, setFiltr] = useState("");
  
  const handleFilter = (e) => {
    setFiltr(e.target.value);
    setCount(IncomingData.filter((x) => x.td4 === e.target.value));
  };

  const handle1 = () => {
    setType(0);
  };
  const handle2 = () => {
    setType(1);
  };
  const handle3 = () => {
    setType(2);
  };
  useEffect(() => {
    if (type === 1) {
      setCount(
        IncomingData.filter(
          (x) => x.td4 === "Unpaid" || x.td4 === "Overdue"
        )
      );
    } else if (type === 2) {
      setCount(IncomingData.filter((x) => x.td4 === "Paid"));
    } else {
      setCount("");
    }
    setFiltr("");
  }, [type]);


  return (
    <div id="OMS-main-content" style={{ marginTop: "2rem" }}>
      <div className="order-list-box" id="account-table">
        <div className="table_heading">
          <h4>INVOICES</h4>
          <OpenInNewIcon
            style={{ fontSize: "16", marginLeft: "5" }}
          ></OpenInNewIcon>
        </div>
        <div id="click-data">
          <p onClick={handle1} id={type === 0 ? "clicked-type" : ""}>
            All Invoice
          </p>
          <p onClick={handle2} id={type === 1 ? "clicked-type" : ""}>
            Open Invoice
          </p>
          <p onClick={handle3} id={type === 2 ? "clicked-type" : ""}>
            Past Invoice
          </p>
        </div>
        <div className="order-list-input-box">
          <div className="order-list-input-left">
            <input
              type="text"
              placeholder="Search by invoice ID, Ship to name"
              onChange={(val) => {
                setCount(
                  IncomingData.filter((x) =>
                    x.td1.match(val.target.value) || x.td3.match(val.target.value)
                  )
                );
                setFiltr("");
                setType(0);
              }}
            />
            <div className="searchIcon">
              <SearchIcon
                style={{
                  color: "#fff",
                  width: "20",
                  height: "20",
                  margin: "5 5",
                }}
              ></SearchIcon>
            </div>
          </div>
          <div className="supplier-content-input-right">
            <select
              name=""
              id=""
              className="supplier-content-input-right-filters"
              value={filtr}
              onChange={handleFilter}
            >
              <option selected>Order Status</option>
              <option value="Paid">Paid</option>
              <option value="Unpaid">Unpaid</option>
              <option value="Overdue">Overdue</option>
            </select>
            <CSVLink
              data={IncomingData}
              className="supplier-content-input-right-filters"
              style={{ display: "flex", alignItems: "center" }}
            >
              Explore List
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </CSVLink>
          </div>
        </div>
        <table style={{ textAlign: "center" }}>
          <tr>
            <th>Invoice ID</th>
            <th>Bill to name</th>
            <th>Ship to name</th>
            <th id="center">Status</th>
            <th id="center">Amount</th>
            <th>Date</th>
            <th>Time</th>
            <th>Payment</th>
            <th>Details</th>
          </tr>
          {count.length > 0
            ? count.map((val) => {
                return (
                  <tr>
                    <td className="invoice-id">{val.td1}</td>
                    <td>{val.td2}</td>
                    <td>{val.td3}</td>
                    <td
                      className="col-status"
                      id={
                        val.td4 === "Paid"
                          ? "col-green"
                          : val.td4 === "Unpaid"
                          ? "col-red"
                          : val.td4 === "Overdue"
                          ? "col-yellow"
                          : ""
                      }
                    >
                      {val.td4}
                    </td>
                    <td id="center">{val.td5}</td>
                    <td>{val.td6}</td>
                    <td>{val.td7}</td>
                    <td>{val.td8}</td>
                    <td className="view-details">{val.td9}</td>
                  </tr>
                );
              })
            : IncomingData.map((val) => {
                return (
                  <tr>
                    <td className="invoice-id">{val.td1}</td>
                    <td>{val.td2}</td>
                    <td>{val.td3}</td>
                    <td
                      className="col-status"
                      id={
                        val.td4 === "Paid"
                          ? "col-green"
                          : val.td4 === "Unpaid"
                          ? "col-red"
                          : val.td4 === "Overdue"
                          ? "col-yellow"
                          : ""
                      }
                    >
                      {val.td4}
                    </td>
                    <td id="center">{val.td5}</td>
                    <td>{val.td6}</td>
                    <td>{val.td7}</td>
                    <td>{val.td8}</td>
                    <td className="view-details">{val.td9}</td>
                  </tr>
                );
              })}
        </table>
      </div>
    </div>
  );
};

export default DashBoardInvoiceTable;
